import React, { createContext, useEffect, useState } from 'react';
import { useFetchExam } from '../api/exam/useFetchExam';
import { useFetchExams } from '../api/exam/useFetchExams';
import { useExamModals } from '../hooks/useExamModals';
import { useSnackbarNotification } from '../hooks/useSnackbarNotification';

export const ExamContext = createContext();

export const ExamProvider = ({ children }) => {
	const {
		activeExam,
		setActiveExam,
		fetchExam,
		countdown,
		displayTimesUp,
		setCountdown,
		lastCountdownValue,
		setDisplayTimesUp,
		durationInSeconds,
		finishExam,
		setDurationInSeconds,
		error: errorExam,
		isLoading: loadingExamFetch
	} = useFetchExam();

	const {
		exams,
		setExams,
		pagination,
		setPagination,
		refetchExams,
		resetPagination,
		fetchExams,
		isLoading: loadingExams
	} = useFetchExams();

	const { openExamModal, setOpenExamModal, openResultModal, setOpenResultModal } = useExamModals();
	const { showPremiumNotification, showPremiumPlusNotification } = useSnackbarNotification();

	const [openEndExamDialog, setOpenEndExamDialog] = useState(false);
	const [isGenerated, setIsGenerated] = useState(false);
	const [questionNumber, setQuestionNumber] = useState(null);

	// Handle exam fetch and countdown start
	useEffect(() => {
		if (activeExam) {
			setOpenExamModal(true);
		}
	}, [activeExam]);

	const handleContinueTest = () => {
		setOpenEndExamDialog(false);
	};

	const handleFinishExam = (activeExam) => {
		console.log('finish exam');
		if (activeExam) {
			setActiveExam(activeExam);
		}
		finishExam();
		setOpenResultModal(true); // Show the results modal
	};

	const handleAbandonTest = () => {
		finishExam();
		setDisplayTimesUp(false);
		setActiveExam(null);
		setOpenExamModal(false);
		setOpenResultModal(false);
		setOpenEndExamDialog(false);
	};

	useEffect(() => {
		if (errorExam && (errorExam.status == 402 || errorExam.status == 420)) {
			showPremiumPlusNotification(
				'Achiziționează access Premium Plus+ pentru a rezolva teste fără limită.'
			);
		}
	}, [errorExam]);

	return (
		<ExamContext.Provider
			value={{
				activeExam,
				loadingExamFetch,
				setActiveExam,
				exams,
				countdown,
				setCountdown,
				displayTimesUp,
				lastCountdownValue,
				setExams,
				openExamModal,
				setOpenExamModal,
				openResultModal,
				setOpenResultModal,
				questionNumber,
				setQuestionNumber,
				pagination,
				setPagination,
				setIsGenerated,
				isGenerated,
				durationInSeconds,
				setDurationInSeconds,
				resetPagination,
				fetchExam,
				errorExam,
				loadingExams,
				fetchExams,
				refetchExams,

				setOpenEndExamDialog,
				openEndExamDialog,
				handleFinishExam,
				handleContinueTest,
				handleAbandonTest
			}}
		>
			{children}
		</ExamContext.Provider>
	);
};
